export default function MonthTimelineDisplay({
    renderRangeStart,
    renderRangeEnd,
    DateToTrackLeftX = () => { return 0 }
}) {

    const monthBars = []

    const monthCursor = renderRangeStart.clone().startOf('month')

    while (monthCursor.isSameOrBefore(renderRangeEnd, 'month')) {
        const monthStart = monthCursor.clone()

        const left = DateToTrackLeftX(monthStart)

        monthBars.push({
            key: monthStart.format('YYYY-MM'),
            left,
            width: DateToTrackLeftX(monthStart.clone().add(1, 'month')) - left,
            label: monthStart.format('MMMM YYYY'),
        })
        
        monthCursor.add(1, 'month')
    }

    return (
        <div className='relative h-4 2xl:h-5'>
            {monthBars.map((month) => (
                <div
                    key={month.key}
                    className='absolute bottom-0 h-4 2xl:h-5'
                    style={{ 
                        left: `${month.left}px`, 
                        width: `${month.width}px` 
                    }}
                >
                    <div className='h-full flex items-center justify-center border-x-[0.5px] border-y-[1px] border-gray-400 overflow-hidden'>
                        <span className='text-xxs 2xl:text-xs font-medium whitespace-nowrap px-1'>
                            {month.label}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    )
}